import { createContext } from 'react'

const WebsocketActionsContext = createContext({
  pendingActions: {},
  setPendingWebsocketAction: () => {},
  clearPendingWebsocketAction: () => {},
})

export default WebsocketActionsContext
